import { injectable } from "inversify";
import UserRepository from "../../../domain/repositories/UserRepository";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../../domain/entities/ErrorEntity";
import UserEntity, { UserType } from "../../../domain/entities/UserEntity";
import SearchResultEntity from "../../../domain/entities/SearchResultEntity";
import SearchUsersApiImpl from "./api/SearchUsersApiImpl";
import UserRepositoryFake from "./UserRepositoryFake";
import CreateUserApiImpl from "./api/CreateUserApiImpl";
import GetUserByIdApiImpl from "./api/GetUserByIdApiImpl";
import DeleteUserApiImpl from "./api/DeleteUserApiImpl";
import SearchUsersForShiftApiImpl from "./api/SearchUsersForShiftApiImpl";
import UpdateUserApiImpl from "./api/UpdateUserApiImpl";

@injectable()
class UserRepositoryImpl implements UserRepository {
    searchUsersForShift = async (_:{query?: string, scheduleId: string, date: Date}): Promise<Either<ErrorEntity, UserEntity[]>> => SearchUsersForShiftApiImpl(_);
    updateUser = (_: {
        user: UserEntity,
        password?: string,
    }): Promise<Either<ErrorEntity, UserEntity>> => UpdateUserApiImpl(_);
    fakeRepostiory: UserRepositoryFake = new UserRepositoryFake();
    createUser = async (_: {
        user: UserEntity,
        password: string,
    }): Promise<Either<ErrorEntity, UserEntity>> => CreateUserApiImpl(_);
    searchUsers = (_: {
        query?: string, page: number, itemsPerPage: number,
        role?: UserType
    }): Promise<Either<ErrorEntity, SearchResultEntity<UserEntity>>> => SearchUsersApiImpl(_);
    getUserById = async (id: string): Promise<Either<ErrorEntity, UserEntity>> => GetUserByIdApiImpl(id);
    deleteUser = (id: string): Promise<Either<ErrorEntity, void>> => DeleteUserApiImpl(id);
}

export default UserRepositoryImpl;